import { IMicrofrontendManifest } from '@cian/mf-registry/shared';

import { FC } from 'react';

import { AdBannerMicrofrontendContainer } from 'shared/containers/AdBannerMicrofrontendContainer';

import { useAdditionalFiltersParameters } from './hooks';

export interface IAdBannerMicrofrontendAdditionalFiltersContainerProps {
  manifest: IMicrofrontendManifest;
  onStub?(): void;
  onError?(): void;
}

/** Баннер в расширенных фильтрах, отрисованный микрофронтендом ad-banner-frontend */
export const AdBannerMicrofrontendAdditionalFiltersContainer: FC<
  IAdBannerMicrofrontendAdditionalFiltersContainerProps
> = ({ manifest, onStub, onError }) => {
  const parameters = useAdditionalFiltersParameters();

  return (
    <AdBannerMicrofrontendContainer manifest={manifest} parameters={parameters} onStub={onStub} onError={onError} />
  );
};
